import { t } from 'i18next';
import { z } from 'zod';
import { InputRegexMap, OnboardingFormFields } from '@Types/index.ts';
import { ControlledTextInput } from './ControlledInputs';
const MIN_NAME_CHARS = 2;
const MAX_NAME_CHARS = 30;
interface IProps {
  disabled?: boolean;
  tabIndex: number;
}
export const FirstNameInput = ({ disabled = false, tabIndex }: IProps) => {
  return (
    <ControlledTextInput
      data-testid='first-name-input'
      name={OnboardingFormFields.FIRST_NAME}
      title={t('pages.home.firstName')}
      id={OnboardingFormFields.FIRST_NAME}
      disabled={disabled}
      tabindex={tabIndex}
      isPublic={false}
    />
  );
};

export const getFirstNameScheme = () =>
  z.object({
    [OnboardingFormFields.FIRST_NAME]: z
      .string()
      .trim()
      .min(1, t('enErrors:required'))
      .min(MIN_NAME_CHARS, t('enErrors:personalDetails.firstNameMinChars'))
      .max(MAX_NAME_CHARS, t('enErrors:firstNameTooLong'))
      .regex(InputRegexMap.firstName, t('enErrors:personalDetails.firstNameNonLetters')),
  });
